import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d3dea9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cameraContainer" }
const _hoisted_2 = {
  key: 0,
  class: "cameraList"
}
const _hoisted_3 = { style: {"padding":"5px"} }

import { useRoute } from 'vue-router';
import { CameraState, Camera } from '@/store/modules/camera/types';
import { computed, onMounted, ref } from 'vue';
import { cameraAPI } from '@/api/camera';
import { baseUrl } from "@/requests";



import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "CameraWindow",
});




export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])

const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);

const cameraState = ref({
    cameras: [],
    isLoading: false
} as CameraState)
const previewList = ref([] as string[])
const Selectedtime = ref("" as string)
const timeOptions = [
    {
        value: 'today',
        label: '今天',
    },
    {
        value: 'week',
        label: '一周内',
    },
    {
        value: 'month',
        label: '一个月内',
    },
    {
        value: '',
        label: '全部',
    },
]
const handleSelectTime = async () => {
    try {
        const projId = projectId.value
        const uid = targetId.value
        const time = Selectedtime.value
        let response: Camera[]
        if (time === "") {
            response = await cameraAPI.getCameraListByUid(projId, uid);
        } else {
            response = await cameraAPI.getCameraListByUidAndTime(projId, uid, time);
        }
        cameraState.value.cameras = response
        previewList.value = getPreviewList(response)
    } catch (err) {
        console.log(err)
        cameraState.value.cameras = []
    } finally {
        cameraState.value.isLoading = false
    }
}
const getPreviewList = (data: Camera[]): string[] => {
    let previewList: string[] = []
    for (let i = 0; i < data.length; i++) {
        previewList.push(baseUrl + '/' + data[i].picSrc)
    }
    return previewList
}
const getPicName = (path: string): string => {
    let split = path.split("/", -1);
    let splitName = split[split.length - 1].split('.', -1);
    let date = new Date(Number(splitName[0]) * 1000)
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
}

onMounted(async () => {
    cameraState.value.isLoading = true
    try {
        const projId = projectId.value
        const uid = targetId.value;
        const response = await cameraAPI.getCameraListByUid(projId, uid);
        cameraState.value.cameras = response
        previewList.value = getPreviewList(response)
    } catch (err) {
        console.log(err)
        cameraState.value.cameras = []
    } finally {
        cameraState.value.isLoading = false
    }
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_text, null, {
      default: _withCtx(() => [
        _createTextVNode("选择时间范围： "),
        _createVNode(_component_el_select, {
          modelValue: Selectedtime.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((Selectedtime).value = $event)),
          onChange: handleSelectTime
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeOptions, (item) => {
              return _createVNode(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (cameraState.value.cameras.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cameraState.value.cameras, (pic, index) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: 4,
                  key: pic
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      "body-style": { padding: '10px', height: '100px' },
                      shadow: "never"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          style: {"width":"70px","height":"70px"},
                          src: _unref(baseUrl) + '/' + pic.picSrc,
                          "preview-src-list": previewList.value,
                          "initial-index": index,
                          title: "点击查看图片"
                        }, null, 8, ["src", "preview-src-list", "initial-index"]),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(getPicName(pic.picSrc)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          "image-size": 200
        }))
  ])), [
    [_directive_loading, cameraState.value.isLoading]
  ])
}
}

})